import React from 'react';
import { Box } from '@mui/material';

const TabPanel = ({children, value, index}) => {
    return (
        <div
          role="tabpanel"
          hidden={value !== index} // Show this panel only when its tab is active
          id={`tabpanel-${index}`}
          aria-labelledby={`tab-${index}`}
        >
          {value === index && <Box sx={{ p: 3 }}>{children}</Box>} {/* Render children */}
        </div>
      );
}

export default TabPanel